import React, { ButtonHTMLAttributes } from 'react';

import { FaTrashAlt } from 'react-icons/fa';

import { Container } from './styles';

export interface IDeleteProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  marginLeft?: string;
}

const Delete: React.FC<IDeleteProps> = ({ ...rest }) => {
  return (
    <Container {...rest}>
      <FaTrashAlt size={16} />
    </Container>
  );
};

export default Delete;
